import { faKey } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { IUser } from "../../Types/User/User.type";

import './Style/User.css';
import { useState } from "react";
import { resetPassword } from "../../Utils/Auth/ResetPassword";
import useSwalToast from "../../Hooks/useSwalToast";

interface IUserProps {
    user: IUser
}

const User: React.FC<IUserProps> = ({ user }) => {
    const [isReadOnly ] = useState<boolean>(true);
    const [displayName, setDisplayName] = useState<string | undefined>(user.displayName)
    const [email, setEmail] = useState<string | undefined>(user.email)
    const [role, setRole] = useState<'Admin' | 'User' | undefined>(user.role)

    const handleChangeDisplayName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDisplayName(e.currentTarget.value);
    }
    const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.currentTarget.value);
    }
    const handleChangeRole = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if(e.currentTarget.value === 'Admin' || e.currentTarget.value === 'User'){
            setRole(e.currentTarget.value);
        }
    }
    
    const { showToast } = useSwalToast();
    const handlePasswordResetEmail = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        if(!user.email){
            showToast('error', 'Erro ao solicitar resete de senha');
            return;
        }
        const {status, message} = await resetPassword(user.email);

        if(status === false){
            showToast('error',message);
            return;
        }

        showToast('success', message);
    }

    return (
        <li key={user.id} className='user'>
            <input className='user-input' readOnly={isReadOnly} type="text" id='user-displayname' value={displayName} onChange={handleChangeDisplayName}></input>
            <input className='user-input' readOnly={isReadOnly} type="text" id='user-email' value={email} onChange={handleChangeEmail}></input>
            <select className='user-input' disabled={isReadOnly} id='user-role' value={role} onChange={handleChangeRole}>
                <option value="Admin">Administrador</option>
                <option value="User">Usuario</option>
            </select>
            {/* {isReadOnly ? 
            <button className='edit-button' onClick={handleEnabelUserEdit}>
                <FontAwesomeIcon icon={faPencil} size='2x'/>
                <small>Editar</small>
            </button> : 
            <button className='edit-button' onClick={handleEnabelUserEdit}>
                <FontAwesomeIcon icon={faSave} size='2x'/>
                <small>Salvar Alterações</small>
            </button>
            } */}
            <button className='pass-reset' onClick={handlePasswordResetEmail}>
                <FontAwesomeIcon icon={faKey} size='2x'/>
                <small>Recuperar Senha</small>
            </button>
        </li>
    )
}

export default User